import { useQuery } from '@tanstack/react-query'
import {
  fetchApplicantPayments,
  UseApplicantPaymentsParams,
} from '@/app/apis/Applicants/requests'
import { type PaginatedApplicantPaymentResponse } from '@/app/apis/Applicants/schema'
import { type RequestError } from '@/common/types_and_interfaces'

export const useGetApplicantPayments = ({
  page = 1,
  perPage = 10,
  globalOnId = 1,
  search = '',
  programId = 0,
  applicantId = 0,
}: UseApplicantPaymentsParams = {}) => {
  return useQuery<PaginatedApplicantPaymentResponse, RequestError>({
    queryKey: [
      'applicantPayments',
      { page, perPage, search, programId, applicantId },
    ],
    queryFn: () =>
      fetchApplicantPayments({
        page,
        perPage,
        globalOnId,
        search,
        programId,
        applicantId,
      }),
    refetchOnMount: 'always',
  })
}
